import { createContext } from 'react';
const INITIAL_STATE = {
    hasInteracted: false,
    isClientSide: false,
    isFailed: false,
    isInitialized: false,
    isOpen: false,
    localStorageState: [],
    ping: Symbol(),
    strictMode: false,
};
export const UsercentricsContext = createContext(INITIAL_STATE);
